<template>
  <div class="layout-wrapper layout-2" :class="{'ai-chat-visible': $root.aiChatSidebarVisible && $root.aiChatAdditionalMetadata && $root.aiChatAdditionalMetadata.suggestionsEnabled}">
    <div class="layout-inner" v-if="$root.me">
      <app-layout-sidenav />

      <div class="layout-container">
        <app-layout-navbar />

        <div class="layout-content">
          <div class="router-transitions container-fluid flex-grow-1 container-p-y">
            <router-view />
          </div>

          <app-layout-footer />
        </div>
      </div>

      <!-- AI Chat Sidebar -->
      <ai-chat-sidebar
        v-show="$root.aiChatSidebarVisible && $root.aiChatAdditionalMetadata && $root.aiChatAdditionalMetadata.suggestionsEnabled"
        @chat-ready="onChatReady"
      />

      <div class="exatom-chat-button" @click="$root.toggleAiChatSidebar()" v-if="$root.aiChatAdditionalMetadata && $root.aiChatAdditionalMetadata.suggestionsEnabled && !($route.meta && $route.meta.hideAiChatToggle)">
        <svg class="exatom-chat-button-shape" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 68 68" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <linearGradient id="exatom-chat-button-shape-stroke"  x1="0" x2="1" y1="0" y2="1">
              <animate attributeType="XML" attributeName="x1"
                       values="0; 1; 1; 0; 0"
                       keyTimes="0; 0.25; 0.5; 0.75; 1"
                       dur="2s" repeatCount="indefinite"/>
              <animate attributeType="XML" attributeName="y1"
                       values="0; 0; 1; 1; 0"
                       keyTimes="0; 0.25; 0.5; 0.75; 1"
                       dur="2s" repeatCount="indefinite"/>
              <animate attributeType="XML" attributeName="x2"
                       values="1; 0; 0; 1; 1"
                       keyTimes="0; 0.25; 0.5; 0.75; 1"
                       dur="2s" repeatCount="indefinite"/>
              <animate attributeType="XML" attributeName="y2"
                       values="1; 1; 0; 0; 1"
                       keyTimes="0; 0.25; 0.5; 0.75; 1"
                       dur="2s" repeatCount="indefinite"/>
              <stop offset="0%" stop-color="#ea58f8"/>
              <stop offset="50%" stop-color="#b28df2"/>
              <stop offset="100%" stop-color="#a0f7fc"/>
            </linearGradient>
          </defs>
          <path d="M60 30C60 51.25 51.25 60 30 60C8.75 60 1.99634e-09 51.25 1.99563e-09 30C1.99492e-09 8.75 8.75 0 30 0C51.25 0 60 8.75 60 30Z" stroke="url(#exatom-chat-button-shape-stroke)"></path>
          <path d="M60 30C60 51.25 51.25 60 30 60C8.75 60 1.99634e-09 51.25 1.99563e-09 30C1.99492e-09 8.75 8.75 0 30 0C51.25 0 60 8.75 60 30Z" stroke="white"></path>
        </svg>
        <i class="exatom-chat-button-icon material-icons" :title="$root.aiChatSidebarVisible ? 'Close AI Chat' : 'Open AI Chat'">
          {{ $root.aiChatSidebarVisible ? 'chat_bubble' : 'chat_bubble_outline' }}
        </i>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
  </div>
</template>

<script>
import LayoutNavbar from './LayoutNavbar'
import LayoutSidenav from './LayoutSidenav'
import LayoutFooter from './LayoutFooter'
import AiChatSidebar from './AiChatSidebar'

export default {
  name: 'exatom',
  components: {
    'app-layout-navbar': LayoutNavbar,
    'app-layout-sidenav': LayoutSidenav,
    'app-layout-footer': LayoutFooter,
    'ai-chat-sidebar': AiChatSidebar
  },

  created () {
    this.$root.me = null
  },

  mounted () {
    this.layoutHelpers.init()
    this.layoutHelpers.update()
    this.layoutHelpers.setAutoUpdate(true)
    this.$root.reload()
    // Load AI chat sidebar state from localStorage
    this.$root.loadAiChatState()
  },

  beforeDestroy () {
    this.layoutHelpers.destroy()
  },

  methods: {
    closeSidenav () {
      this.layoutHelpers.setCollapsed(true)
    },

    onChatReady (chatInstance) {
      // Additional chat configurations can be done here
    }
  }
}
</script>

<style lang="scss" scoped>
// Layout adjustments when chat sidebar is visible
.layout-wrapper.ai-chat-visible {
  .layout-container {
    margin-right: 415px;
    transition: margin-right 0.3s ease-in-out;
  }

  @media (min-width: 1441px) {
    .layout-container {
      margin-right: 465px;
    }
  }

  // On small screens, don't apply margin
  @media (max-width: 768px) {
    .layout-container {
      margin-right: 0;
    }
  }

  // Adjustment for smaller screens
  @media (max-width: 1200px) {
    .layout-container {
      margin-right: 350px;
    }
  }
}

// Specific adjustments when left sidebar is collapsed and AI chat visible
.layout-collapsed.ai-chat-visible {
  .layout-container {
    margin-right: 400px;
    margin-left: 4.375rem; // width of collapsed sidebar

    @media (max-width: 768px) {
      margin-right: 0;
      margin-left: 0;
    }

    @media (max-width: 1200px) {
      margin-right: 350px;
    }
  }
}

// Ensure the inner layout has full height
.layout-inner {
  min-height: 100vh;
  position: relative;
}

.exatom-chat-button-shape>path:nth-of-type(1) {
  animation: 10s linear infinite;
  stroke-width: 4px;
}

.exatom-chat-button-shape>path:nth-of-type(2) {
  stroke-width: 1px;
}

.exatom-chat-button {
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 1024;
  width: 60px;
  height: 60px;
  margin: 0;
  padding: 0;
  background: transparent;
  transition: all 0.2s ease-in-out;
  transform-origin: center center;
  cursor: pointer;
}
.exatom-chat-button:hover {
  transform: scale(1.05);
}
.exatom-chat-button .exatom-chat-button-shape {
  position: absolute;
  left: 0;
  top: 0;
  width: 60px;
  height: 60px;
  fill: #007dfd;
  cursor: pointer;
}
.exatom-chat-button .exatom-chat-button-icon {
  position: absolute;
  left: 18px;
  top: 18px;
  width: 32px;
  height: 32px;
  color: #FFFFFF;
  cursor: pointer;
}
</style>
